import React, { useState, useEffect } from 'react';
import '../css/global.css';

const ScrollToTop = () => {
  const [showButton, setShowButton] = useState(false);

  // Kullanıcı sayfayı 100px'den fazla aşağı kaydırdığında butonu göster (300px'den 100px'e düşürüldü)
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 100) {
        setShowButton(true);
      } else {
        setShowButton(false);
      }
    };

    // Başlangıçta scroll pozisyonunu kontrol et
    handleScroll();

    // Scroll olayını dinle
    window.addEventListener('scroll', handleScroll);

    // Component unmount olduğunda event listener'ı temizle
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  // Sayfanın en üstüne kaydırma fonksiyonu
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  return (
    <div className="scroll-button-container">
      {showButton && (
        <button 
          className="scroll-to-top visible" 
          onClick={scrollToTop}
          aria-label="Sayfanın en üstüne çık"
          title="Yukarı Çık"
        >
          ↑
        </button>
      )}
    </div>
  );
};

export default ScrollToTop; 